import moment from "moment";

export const reviver = (_: any, value: any) => {
  const formats = [moment.ISO_8601, "MM/DD/YYYY"];
  if (typeof value === "string") {
    if (moment(value, formats, true).isValid()) {
      return new Date(value);
    }
  }
  return value;
};

export const replacer = (_: any, value: any) => {
  if (typeof value === "string") {
    if (Date.parse(value)) {
      const date = new Date(value);
      if (date.toISOString() === value) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${year}-${month}-${day}`;
      }
    }
  }
  return value;
};
